import { AdjustmentDto } from "@admin_api/models/adjustment-dto";

export class AdjustmentState {
    loading = false;
    error = null;
    record: AdjustmentDto = null;
}
